// src/routes/UserRoutes.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import MemberLayout from "../layouts/MemberLayout";
import NotFound from "../pages/static/NotFound";
import Dashboard from "../pages/user/Dashboard";
import Settings from "../pages/user/Settings";
import Library from "../pages/user/Library";
import Tasks from "../pages/user/Tasks";
import MyJourney from "../pages/user/MyJourney";
import Fellows from "../pages/user/Fellows";
import Community from "../pages/user/Community";

const UserRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Layout Route */}
      <Route element={<MemberLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/library" element={<Library />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/journey" element={<MyJourney />} />
        <Route path="/fellows" element={<Fellows />} />
        <Route path="/community" element={<Community />} />
        

        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default UserRoutes;
